var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('apexchart',{key:_vm.processo.oid + _vm.id,staticClass:"justify-center d-flex",attrs:{"type":"pie","width":"600","options":_vm.pieOptions,"series":_vm.pieSeries}})}
var staticRenderFns = []

export { render, staticRenderFns }